import React from 'react'

import queryString from 'query-string'

import { ZariContext } from '_zari/context'
import { Portlet, Table, Alert, Row, Col, Form, Button } from '_zari/core'

import { CodigosTransaccionesConstant, SeInventarios, TiposOperacionSunat } from 'constants/index'

import * as CentrosCostoService from 'services/centrosCosto.service'

import RowTemplate from './rowTemplate'

const portletBreadcrumbs = [{ name: 'Talleres' }]

const tableHeaderRows = [
  { label: '', width: 45 },
  { label: 'FECHA INGRESO' },
  { label: 'TITULO' },
  { label: 'MONTO' },
  { label: '' }
]

const ListaTalleresPage = ({ history, location }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const parsedQuery = React.useMemo(() => {
    const parsed = queryString.parse(location.search)
    return parsed
  }, [location.search])

  const [centrosNivel1, setCentrosNivel1] = React.useState([])
  const [centrosNivel2, setCentrosNivel2] = React.useState([])
  const [centroSeleccionadoNivel1, setCentroSeleccionadoNivel1] = React.useState(parsedQuery.cc1 || '')
  const [centroSeleccionadoNivel2, setCentroSeleccionadoNivel2] = React.useState(parsedQuery.cc2 || '')

  React.useEffect(() => {
    CentrosCostoService.obtenerxNivel(1).then(({ data }) => {
      setCentrosNivel1(data)
    })
  }, [])

  const clickNuevo = React.useCallback(() => {
    if (!centroSeleccionadoNivel2 === 0) {
      __zariContext.snack('error', 'No se ha seleccionado centro de costo alguno.')
      return
    }

    let objetoUrl = {
      cc1: centroSeleccionadoNivel1,
      cc2: centroSeleccionadoNivel2
    }

    history.push(`/${CodigosTransaccionesConstant.TALLERES_NUEVO_EDITAR}?${queryString.stringify(objetoUrl)}`)
  }, [history, centroSeleccionadoNivel2, centroSeleccionadoNivel1, __zariContext])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      if (!centroSeleccionadoNivel2 === 0) {
        __zariContext.snack('error', 'No se ha seleccionado centro de costo alguno.')
        return
      }

      let objetoUrl = {
        cc1: centroSeleccionadoNivel1,
        cc2: centroSeleccionadoNivel2
      }

      history.push(`/${CodigosTransaccionesConstant.TALLERES_NUEVO_EDITAR}/${_id}?${queryString.stringify(objetoUrl)}`)
    },
    [history, centroSeleccionadoNivel1, centroSeleccionadoNivel2, __zariContext]
  )

  const onChangeCentro1 = React.useCallback(e => {
    const nuevoValor = e.target.value

    setCentroSeleccionadoNivel1(nuevoValor)
    setCentroSeleccionadoNivel2('')

    if (nuevoValor) {
      CentrosCostoService.obtenerNodosHijosxIdAsSelect(nuevoValor).then(({ data }) => {
        if (data) {
          setCentrosNivel2(data)
        }
      })
    } else {
      setCentrosNivel2([])
    }
  }, [])

  const clickBuscar = React.useCallback(() => {
    if (!centroSeleccionadoNivel2) {
      __zariContext.snack('error', `No se ha seleccionado centro de nivel 2.`)
      return
    }

    tablaRef.current.reload({
      idCentroCostoNivel2: centroSeleccionadoNivel2
    })
  }, [__zariContext, centroSeleccionadoNivel2])

  const clickAgregarSalida = React.useCallback(
    ({ _id }) => {
      if (!centroSeleccionadoNivel2 === 0) {
        __zariContext.snack('error', 'No se ha seleccionado centro de costo alguno.')
        return
      }

      let objetoUrl = {
        t: SeInventarios.SALIDA,
        to: TiposOperacionSunat.SALIDA_POR_SERVICIO_DE_PRODUCCIÓN,
        taller: _id,
        cc1: centroSeleccionadoNivel1,
        cc2: centroSeleccionadoNivel2
      }

      history.push(
        `/${CodigosTransaccionesConstant.INVENTARIOS_ENTRADASALIDA_NUEVO}?${queryString.stringify(objetoUrl)}`
      )
    },
    [history, __zariContext, centroSeleccionadoNivel1, centroSeleccionadoNivel2]
  )

  return (
    <>
      {centrosNivel1.length === 0 ? (
        <Alert color='danger'>No se puede continuar con el proceso, faltan centros de costo.</Alert>
      ) : (
        <>
          <Portlet>
            <Portlet.Header
              title='Talleres'
              breadcrumbs={portletBreadcrumbs}
              buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
            />
            <Portlet.Body>
              <Row>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label text='CENTRO 1' md={12} />
                    <Col md={12}>
                      <Form.Select
                        id='select-centroCostoNivel1'
                        name='select-centroCostoNivel1'
                        value={centroSeleccionadoNivel1}
                        onChange={onChangeCentro1}
                      >
                        <option value=''>Seleccionar</option>
                        {centrosNivel1.map(y => (
                          <option key={y._id} value={y._id}>{`${y.codigo} - ${y.descripcion}`}</option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label text='CENTRO 2' md={12} />
                    <Col md={12}>
                      <Form.Select
                        id='select-centroCostoNivel2'
                        name='select-centroCostoNivel2'
                        value={centroSeleccionadoNivel2}
                        onChange={e => setCentroSeleccionadoNivel2(e.target.value)}
                      >
                        <option value=''>Seleccionar</option>
                        {centrosNivel2.map(y => (
                          <option key={y._id} value={y._id}>{`${y.codigo} - ${y.descripcion}`}</option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                </Col>
                {centroSeleccionadoNivel2 && (
                  <Col md={1}>
                    <Form.Group>
                      <Form.Label text='.' md={12} />
                      <Col md={12}>
                        <Button tiny block onClick={clickBuscar}>
                          Buscar
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <Table.ServerSide
                ref={tablaRef}
                preventFirstRender={!centroSeleccionadoNivel2}
                useNest={true}
                url='/talleres'
                headRows={tableHeaderRows}
                baseParams={
                  centroSeleccionadoNivel2
                    ? {
                        idCentroCostoNivel2: centroSeleccionadoNivel2
                      }
                    : {}
                }
                rowTemplate={row => (
                  <RowTemplate
                    key={row._id}
                    mainRow={row}
                    clickAgregarSalida={clickAgregarSalida}
                    clickEditar={clickEditar}
                    centroSeleccionadoNivel1={centroSeleccionadoNivel1}
                    centroSeleccionadoNivel2={centroSeleccionadoNivel2}
                  />
                )}
              />
            </Portlet.Body>
          </Portlet>
        </>
      )}
    </>
  )
}

export default React.memo(ListaTalleresPage)
